var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContacts = function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16v-5H4v5h2v-3h6v3h2ZM24 9h-8V7h8v2ZM16 13h8v-2h-8v2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 20V0H0v18h2v2h26Zm-2-2H2V2h24v16Z",
    fill: "currentColor"
  })));
};

export { SvgContacts as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOSAxMEMxMC42NTY5IDEwIDEyIDguNjU2ODYgMTIgN0MxMiA1LjM0MzE1IDEwLjY1NjkgNCA5IDRDNy4zNDMxNSA0IDYgNS4zNDMxNSA2IDdDNiA4LjY1Njg2IDcuMzQzMTUgMTAgOSAxMFpNOSA4QzkuNTUyMjkgOCAxMCA3LjU1MjI5IDEwIDdDMTAgNi40NDc3MiA5LjU1MjI5IDYgOSA2QzguNDQ3NzIgNiA4IDYuNDQ3NzIgOCA3QzggNy41NTIyOSA4LjQ0NzcyIDggOSA4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xNCAxNlYxMUg0VjE2SDZWMTNIMTJWMTZIMTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTI0IDlIMTZWN0gyNFY5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xNiAxM0gyNFYxMUgxNlYxM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI4IDIwVjBIMFYxOEgyTDIgMjBIMjhaTTI2IDE4SDJMMiAyTDI2IDJWMThaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";